export const sectionDividerSpecialModule = {
  name: 'Section Divider Special',
};
